import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';

export default function LoginAdmin() {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleSubmit = (e) => {
        e.preventDefault();
        setIsSubmitting(true);

        if (!email || !password) {
            setError('E-posta ve şifre boş olamaz.');
            setIsSubmitting(false);
            return;
        }

        // Simüle edilmiş API çağrısı
        setTimeout(() => {
            if (email.trim().toLowerCase() === 'admin@gmail.com' && password.trim() === 'tepekod1717') {
                localStorage.setItem('auth', 'true');
                localStorage.setItem('role', 'admin');
                navigate('/admin-panel', { replace: true });
            } else {
                setError('Geçersiz admin bilgileri.');
                setIsSubmitting(false);
            }
        }, 1000);
    };

    return (
        <section className="relative w-full min-h-screen bg-gradient-to-br from-[#241c15] via-[#523323] to-[#7F6B52] flex items-center justify-center overflow-hidden">
            {/* Arkaplan animasyonları */}
            <div className="absolute inset-0 overflow-hidden">
                <div className="absolute top-1/4 left-1/4 w-32 h-32 rounded-full bg-[#F9D923]/20 blur-xl animate-float-1"></div>
                <div className="absolute top-1/3 right-1/4 w-40 h-40 rounded-full bg-[#FF914D]/20 blur-xl animate-float-2"></div>
                <div className="absolute bottom-1/4 left-1/3 w-36 h-36 rounded-full bg-[#7F6B52]/20 blur-xl animate-float-3"></div>
            </div>

            <div className="absolute inset-0 w-full h-full bg-gradient-to-br from-[#241c15] via-[#523323] to-[#7F6B52] opacity-80" />

            <div className="relative z-10 flex items-center justify-center min-h-screen px-4 py-10 w-full">
                <motion.form
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5 }}
                    onSubmit={handleSubmit}
                    className="bg-white/20 backdrop-blur-2xl rounded-3xl shadow-2xl max-w-md w-full p-10 border border-[#F9D923]/30 flex flex-col items-center"
                >
                    <h2 className="text-3xl font-extrabold mb-8 text-center bg-gradient-to-r from-[#F9D923] via-[#FF914D] to-[#7F6B52] text-transparent bg-clip-text drop-shadow-lg">
                        Admin Girişi
                    </h2>

                    {error && (
                        <div className="w-full mb-4 overflow-hidden">
                            <p className="text-red-400 text-sm text-center font-semibold bg-white/60 rounded py-2 px-4 border border-red-200 shadow">
                                {error}
                            </p>
                        </div>
                    )}

                    <div className="w-full space-y-4">
                        <div>
                            <input
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder="admin@gmail.com"
                                className="w-full px-4 py-3 border border-[#F9D923]/30 bg-white/40 rounded-xl text-[#241c15] font-medium placeholder-[#523323]/60 focus:outline-none focus:ring-2 focus:ring-[#F9D923] shadow-sm"
                                required
                            />
                        </div>

                        <div>
                            <input
                                type="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                placeholder="Şifre"
                                className="w-full px-4 py-3 border border-[#F9D923]/30 bg-white/40 rounded-xl text-[#241c15] font-medium placeholder-[#523323]/60 focus:outline-none focus:ring-2 focus:ring-[#F9D923] shadow-sm"
                                required
                            />
                        </div>
                    </div>

                    <button
                        type="submit"
                        disabled={isSubmitting}
                        className={`w-full mt-6 py-3 rounded-xl font-bold text-lg bg-gradient-to-r from-[#F9D923] via-[#FF914D] to-[#7F6B52] text-white shadow-lg hover:brightness-110 transition-all duration-300 border-none relative overflow-hidden ${isSubmitting ? 'opacity-80 cursor-not-allowed' : 'hover:scale-105'}`}
                    >
                        {isSubmitting ? (
                            <div className="absolute inset-0 flex items-center justify-center">
                                <div className="w-6 h-6 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                            </div>
                        ) : (
                            'Giriş Yap'
                        )}
                    </button>
                </motion.form>
            </div>

            {/* Animasyon stilleri */}
            <style jsx>{`
                @keyframes float-1 {
                    0%, 100% { transform: translate(0, 0) rotate(0deg); }
                    50% { transform: translate(20px, 20px) rotate(5deg); }
                }
                @keyframes float-2 {
                    0%, 100% { transform: translate(0, 0) rotate(0deg); }
                    50% { transform: translate(-15px, 15px) rotate(-5deg); }
                }
                @keyframes float-3 {
                    0%, 100% { transform: translate(0, 0) rotate(0deg); }
                    50% { transform: translate(10px, -10px) rotate(3deg); }
                }
                .animate-float-1 { animation: float-1 8s ease-in-out infinite; }
                .animate-float-2 { animation: float-2 10s ease-in-out infinite; }
                .animate-float-3 { animation: float-3 12s ease-in-out infinite; }
            `}</style>
        </section>
    );
}